<template lang="pug">
  .row
    .col-md-8.pb-2
      div
        content-loader(:height="7", v-if="alert.loading")
        form.mt-3(v-else-if="inputForm", @submit.prevent='onSubmit')
          .row
            .col-md-6
              b-form-group
                label FIRST NAME
                b-form-input(name='firstname', type='text', v-model='inputForm.firstname', required='',  autocomplete="fname")
            .col-md-6
              b-form-group
                label LAST NAME
                b-form-input(name='lastname', type='text', v-model='inputForm.lastname', required='',  autocomplete="lname")
            .col-md-6
              b-form-group
                label PHONE
                b-form-input(type='tel', v-model='inputForm.phone', required='', pattern="\\d{10}", title='10 Digits only. No +27 or spaces please :)',  autocomplete="tel")
            .col-md-6
              b-form-group
                label EMAIL
                b-form-input(type='email', v-model='inputForm.email', required='',  autocomplete="email")
            .col-6
              b-form-group
                label PASSWORD
                b-form-input(type="password", name="password2", v-model="inputForm.passwordOld", placeholder='Leave blank to keep unchanged')
                //b-form-input(type="password", name="password", v-model="inputForm.passwordOld", placeholder='Leave blank to keep unchanged')
            .col-6
              b-form-group
                // b-form-input(type="password", name="password", v-model="inputForm.passwordNew", placeholder='Leave blank to keep unchanged')
                label NEW PASSWORD
                b-form-input(type="password", name="password2", v-model="inputForm.passwordNew", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}", placeholder='Leave blank to keep unchanged')
            .col-12(v-if="inputForm.passwordNew")
              p Password must be atleast 8 characters, with a number and a capital letter.
          .form-group
            button-load(type="submit", :flag="alert.busy", label="SAVE", classes="btn-outline")
            // b-button.btn-clear(@click="deleteAccount()") Delete Account
    .col-md-4.pb-2
      b-card.mb-2.text-center
        .container
          h4 ACCOUNT VERIFICATION
          content-loader(:height="7", v-if="alert.loading")
          h4.text-success(v-else-if="isVerified")
            span
              font-awesome-icon.mr-2(icon="check")
              span VERIFIED
          div(v-else="")
            p.small We request a quick verification to confirm that you are you, this contributes towards a more secure platform for both our collectors and our artists.
            button-load.mb-3(:flag="busyPersona", label="VERIFY NOW", classes="btn-outline mt-3", @clicked="verifyMe()")
      b-card
        p I consent to
        content-loader(:height="7", v-if="alert.loading")
        form.mt-3(v-else-if="inputForm", @submit.prevent='onSubmit')
          b-form-group
            b-form-checkbox(v-for='item in inputForm.consent', :key="item.id", v-model='item.value', switch) {{ item.display_text }}
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';
import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      busyPersona: false,
      inputForm: null,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
    ...mapMutations('account', ['setAccountVerified']),
    onSubmit() {
      this.updateAccount({ form: this.inputForm, id: this.profileId });
    },
    async verifyMe() {
      if (process.env.NODE_ENV === 'production') {
        this.busyPersona = true;
        // eslint-disable-next-line no-undef
        const client = new Persona.Client({
          templateId: 'tmpl_9sqr29pCrKni743khM4bRq1X',
          environment: process.env.VUE_APP_PERSONA_ENV,
          onLoad: (_error) => {
            client.open(_error);
            this.busyPersona = false;
          },
          onComplete: async (inquiryId) => {
          // Inquiry completed. Optionally tell your server about it.
            console.log(`Sending finished inquiry ${inquiryId} to backend`);
            this.busyPersona = true;
            try {
              await userService.verifyPersona(this.profileId, inquiryId);
              this.setAccountVerified();
              if (this.$route.query.sendmeback) {
                router.push(this.fromUrl);
              } else {
                this.success('Account verified');
              }
            } catch (error) {
              this.error(error);
            }
            this.busyPersona = false;
          },
        });
      } else {
        this.busyPersona = true;
        try {
          await userService.verifyPersona(this.profileId, '0000000000000000');
          this.setAccountVerified();
          if (this.$route.query.sendmeback) {
            router.push(this.fromUrl);
          } else {
            this.success('Account verified');
          }
        } catch (error) {
          this.error(error);
        }
        this.busyPersona = false;
      }
    },
  },
  async created() {
    try {
      this.busy();
      this.inputForm = await userService.getProfile(this.profileId);
      this.clear();
      if (this.$route.query.launch === 'accountVerify') {
        this.verifyMe();
      }
    } catch (error) {
      this.logout();
    }
  },
  mounted() {
    this.$loadScript('https://cdn.withpersona.com/dist/persona-v3.7.3.js')
      .then(() => {
      // Script is loaded, do something
        console.log('Persona ready');
      })
      .catch(() => {
        console.log('Persona failed');
      // Failed to fetch script
      });
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountProfile.vue